import { render, staticRenderFns } from "./customerImg.vue?vue&type=template&id=1ab21de7&"
import script from "./customerImg.vue?vue&type=script&lang=js&"
export * from "./customerImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/upload/customerImg.vue"
export default component.exports